import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextSocialSecurityInfoComponent } from './text-social-security-info.component';

@NgModule({
  declarations: [TextSocialSecurityInfoComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
  ],
  exports:[TextSocialSecurityInfoComponent],
})
export class TextSocialSecurityInfoModule { }
